import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {submit, isSubmitting, formValueSelector} from 'redux-form';

import Button from 'components/Button';
import {default as Modal, withModal} from 'components/Modal';

import {
  MODALS,
  fetchArrivalRoomChecks,
  fetchBookingSet,
  fetchRoomChecksTimeline
} from 'ducks/bookingSets';

import {AddArrivalRoomCheckForm} from './components';

import './styles.css';

class AddArrivalRoomCheckModal extends React.Component<any> {
  triggerSubmit = () => this.props.submit('addArrivalRoomCheck');

  getExtraActions = () => [
    ...this.props.closeModalExtraActions,
    () => fetchArrivalRoomChecks({bookingSetId: this.props.data.bookingSetId}),
    () => fetchBookingSet({bookingSetId: this.props.data.bookingSetId}),
    () => fetchRoomChecksTimeline({bookingSetId: this.props.data.bookingSetId})
  ];

  render() {
    const {
      closeModal,
      form: {submitting},
      data: {bookingSetId},
      selectedRoomValue
    } = this.props;
    return (
      <Modal
        className="AddArrivalRoomCheckModal"
        show={true}
        type={Modal.EXTRA_SMALL}
        onClose={closeModal}>
        <Modal.Header heading="Add arrival room check" />
        <Modal.Body>
          <AddArrivalRoomCheckForm
            bookingSetId={bookingSetId}
            storeDataExtraActions={this.props.storeDataExtraActions}
            getExtraActions={this.getExtraActions}
          />
        </Modal.Body>
        <Modal.Footer className="colab-row-space-between">
          <Button white className="cancel" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            className="add"
            disabled={submitting || _.isNil(selectedRoomValue)}
            blue={!submitting}
            isLoading={submitting}
            onClick={this.triggerSubmit}>
            Add item
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const formSelector = formValueSelector('addArrivalRoomCheck');

const mapStateToProps = state => ({
  form: {
    submitting: isSubmitting('addArrivalRoomCheck')(state)
  },
  selectedRoomValue: formSelector(state, 'room')
});

const mapDispatchToProps = {
  submit
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.ADD_ARRIVAL_ROOM_CHECK)(AddArrivalRoomCheckModal)
);
